// import random from 'lodash/number/random';
import React, { Component } from "react";
import SpringScrollbars from "./SpringScrollbars";

export default class Scroll extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);
    this.scrollRef = React.createRef();
    this.changeSrl = this.props.changesrl?this.props.changesrl.bind(this):()=>{}
  }

  componentDidUpdate(prevProps) {
    if (this.props.updateScroll) {
 
        try {
          const { scrollbars } = this.scrollRef.current.refs;
          const scrollWidth = scrollbars.getScrollWidth();
          const clientWidth = scrollbars.getClientWidth();
          const scrollHeight = scrollbars.getScrollHeight();
          const clientHeight = scrollbars.getClientHeight();
          scrollbars.scrollLeft((scrollWidth - clientWidth) / 2);
          scrollbars.scrollTop((((scrollHeight) - clientHeight) / 2));
          this.props.changesrl();
        } catch (e) {
          console.log(e);
        }

 
     
    }
  }

  render() {
    return (
      <SpringScrollbars ref={this.scrollRef} {...this.props}>
        {this.props.children}
      </SpringScrollbars>
    );
  }
}
